import TrendAnalysisChart from '@/components/TrendAnalysisChart/TrendAnalysisChart.vue'

export default {
  name: 'TrendAnalysisModal',
  components: {
    'trend-analysis-chart': TrendAnalysisChart // Trend Analysis Chart component
  },
  props: {
    trendAnalysisModalVisible: {
      type: Boolean,
      default: false
    },
    /**
     * analysisObj : trendAnalysisChart 검색 object
     * @param {Object} 형식 아래 참조
     *  {
          fromDate: 검색 시작 시간 (YYYYMMDD),
          toDate: 검색 종료 시간 (YYYYMMDD),
          fromTime: 검색 시작 시간 (HHmm),
          toTime: 검색 종료 시간 (HHmm),
          reqParam: [
            {
              fabId: '',
              eqpId: '',
              moduleId: ''
            }
          ],
          paramName: ['paramName', 'paramName'],
          lotId: ['lotId', 'lotId'],
          reqParamName: [
            {
              fab: '',
              eqpId: '',
              moduleId: '',
              paramName: ''
            }
          ]
        }
     */
    analysisObj: {
      type: Object,
      default: null
    }
  },
  watch: {
    /**
     * trendAnalysisModalVisible 변화 감지
     */
    trendAnalysisModalVisible () {
      this.modalVisible = this.trendAnalysisModalVisible
    },
    /**
     * analysisObj 변화 감지
     * @param {Object} value Trend Analysis Chart 관련 Object
     */
    analysisObj (value) {
      this.trendAnalysisChartObj = value
    },
    /**
     * modalVisible
     * @param {Object} value modal visible value
     */
    modalVisible (value) {
      if (value) {
        setTimeout(() => {
          this.$refs.trendAnalysisChart.getDataInitial()
        }, 100)
      }
    }
  },
  methods: {
    /**
     * Modal 닫기
     */
    resetModalData () {
      this.$emit('trend-analysis-modal-visible', false)
    }
  },
  data () {
    return {
      modalVisible: false, // Modal 표시 여부
      trendAnalysisChartObj: null // Trend Analysis Chart 관련 Object
    }
  }
}
